import BaseService from './BaseService'

export default new (class TrackingService extends BaseService {
  constructor() {
    super()
  }

  trackGenericEvent(buttonId, svalues = 'svalues') {
    if (!window.genericEventTracking) {
      return false
    }

    window.genericEventTracking(svalues, buttonId)
    return true
  }
})()
